import { useAtomValue } from "jotai";
import { type FunctionComponent, useState } from "react";

import { rosettaAtom } from "scmp-app/lib/rosetta";

import {
  Container,
  StyledHamburgerMenuSearchArea,
  StyledHamburgerMenuSubscriberInstruction,
} from "./styles";

type Props = {
  className?: string;
  onMenuClose?: () => void;
};
export const HamburgerMenuNonSubPanel: FunctionComponent<Props> = ({ className, onMenuClose }) => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const [isSearchOpened, setIsSearchOpened] = useState<boolean>(true);

  const isShowSubscription =
    !asyncRosettaState?.result?.hasIpAccess &&
    asyncRosettaState?.result?.contentServiceUserInfo?.isSubscriptionEnabled &&
    !asyncRosettaState?.result?.isScmpSubscriber;

  const isShowSubscriptionInstruction = () => {
    if (isShowSubscription) {
      return isSearchOpened;
    }
    return false;
  };

  return (
    <Container className={className}>
      {isShowSubscription && (
        <StyledHamburgerMenuSubscriberInstruction $isShow={isShowSubscriptionInstruction()} />
      )}

      <StyledHamburgerMenuSearchArea
        $isExpanded={!isShowSubscriptionInstruction()}
        defaultExpand={!isShowSubscription}
        onClick={() => setIsSearchOpened(false)}
        onMenuClose={onMenuClose}
      />
    </Container>
  );
};
